import store from './store/index';
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['RegAuth'] = process.env.MIX_REG_AUTH_KEY;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// -- Commenting Out because of issues in API consumption
window.axios.interceptors.response.use(response => response, error => {
    // If unauthorized error and currently logged in?
    // if (error.response.status === 401 && store.getters.GET_AUTH.access_token) {
    //     store.dispatch('logout');
    // }
    if (error && error.response && error.response.status) {
        const code = (Number.parseInt(error.response.status));
        if ((code >= 400 && ![401, 404, 422].includes(code)) || code >= 500) {
            /**
            * Task:     BAUM-432
            * Author:   Joseph Ricohermoso
            * Date:     2021-05-27
            * Desc:     Catch bpoint specific call error and adjust the response data that will be shown in our modal payment error
            */
            if ( error.response.config.url.includes('bpoint-auth') ) {
                const { message, bpointResponseCode } = error.response.data;
                error.response.data.message = `${message}. Please try again. (Status code: ${bpointResponseCode})`;
            } else if ( error.response.config.url.includes('update-password') ||
                        (error.response.config.url.includes('work-order') &&
                            error.response.data &&
                            error.response.data.message &&
                            error.response.data.message.includes('ERROR_WO_EMAIL_NOTIF_FAILURE')) ) {
                const { message } = error.response.data;
                error.response.data.message = message;
            } else if (
                (
                    error.response.config.url.includes('update-queued-booking-status') ||
                    error.response.config.url.includes('available-booking-dates')
                ) &&
                error.response.data &&
                error.response.data.message
            ) {
                const { message } = error.response.data;
                error.response.data.message = message;
            } else {
                error.message = `There was an error encountered while processing your request. Please try again. (Status code: ${code || 500})`;
                error.response.data.message = `${error.message}`;
            }
            // End BAUM-432
        }
    }
    return Promise.reject(error);
});

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
